<template>
  <div class="bottom">
    <!-- <div class="list1">
      <div class="lis1">
        <div class="li-1">
          <span class="text1">

          </span>
          <span class="text2">

          </span>
          <span class="text2">金融资质</span>
          <span class="text2" style="margin-left:35px">

          </span>
        </div>
        <div class="li-2">
          <span class="text1">
            <router-link :to="{ path: '/userService' }">法规文件 |</router-link>
          </span>
          <span class="text2">
            <router-link :to="{ path: '/userService' }">服务协议</router-link>
          </span>
          <span class="text2">
            <router-link :to="{ path: '/userService' }">风险评估表</router-link>
          </span>
          <span class="text2">

          </span>
        </div>
        <div class="li-3">
          <span class="text1">

          </span>
          <span class="text2">
            <router-link :to="{ path: '/userService' }">常见问题</router-link>
          </span>
          <span class="text2">
            <router-link :to="{ path: '/userService' }">收款公示</router-link>
          </span>
        </div>
      </div>
      <div class="lis2">
        <div class="li-1">客服电话</div>
        <div class="li-2">交易日: 09:30-15:00</div>
        <div class="li-3">申诉热线: <span>400-xxxx-xxx</span> </div>
        <div class="li-4">咨询热线: <span>400-xxxx-xxx</span> </div>
      </div>
      <div class="lis3">
        <div class="li-1">
          <img src="../assets/img/qr1.png" alt="">
          <span>官方公众号：天相财富</span>
        </div>
        <div class="li-1">
          <img src="../assets/img/qr2.png" alt="">
          <span>官方小程序：天相财富</span>
        </div>
      </div>
    </div> -->
    <div class="list1">
      <div class="l">
        <div class="liss" style="padding-top:35px;margin-bottom:42px">

          <img src="../assets/img/index/bottom/222.png" alt="" />
        </div>
        <div class="liss2">客服电话</div>
        <div class="liss3" style="margin-bottom:5px">投诉电话：400-101-8662</div>
        <div class="liss3">咨询热线：010-66045051</div>
        <div class="liss1">交易日:</br>09:00-11:30 13:00-18:00</div>
      </div>
      <img src="../assets/img/index/bottom/shu.png" alt="">
      <div class="c">
        <div class="lis" style="padding-left:81px">
          <div class="p1">
            <router-link :to="{ path: '/aboutUs' }">关于我们 </router-link>
          </div>
          <div class="p2">
            <router-link :to="{ path: '/aboutUs' }">公司简介</router-link>
          </div>
          <div class="p3">金融资质</div>
          <div class="p4">
            <router-link :to="{ path: '/aboutUs' }">产品</router-link>
          </div>
        </div>
        <div class="shus shus1">|</div>
        <div class="lis">
          <div class="p1">
            <router-link :to="{ path: '/userService' }">法规文件</router-link>
          </div>
          <div class="p2">
            <router-link :to="{ path: '/userService' }">服务协议</router-link>
          </div>
          <div class="p3">
            <router-link :to="{ path: '/userService' }">风险评估表</router-link>
          </div>
          <div class="p4">
            <router-link :to="{ path: '/userService' }">风险揭示书</router-link>
          </div>
        </div>
        <div class="shus shus2">|</div>
        <div class="lis">
          <div class="p1">
            <router-link :to="{ path: '/userService' }">其他服务 </router-link>
          </div>
          <div class="p2">常见问题</div>
          <div class="p3">收款公示</div>

        </div>
      </div>
      <img src="../assets/img/index/bottom/shu.png" alt="">
      <div class="r">
        <div class="lis1">
          <div class="liss1">
            <img src="../assets/img/qr1.jpg" alt="">
          </div>
          <p>官方服务号：天相股多多</p>
        </div>
        <div class="lis2">
          <div class="liss1">
            <img src="../assets/img/qr4.png" alt="">
          </div>
          <p>官方服务号：股多多擒龙指南</p>
        </div>
      </div>
    </div>
    <div class="list2">
      <div class="text1">投资有风险，入市需谨慎！</div>
      <div class="text2">业务资格许可证编号：91110102MA001GJE1N</div>
      <div class="text2">使用天相财富提供的服务之前，请完整阅读我们的风险披露及条款声明&nbsp;天相财富是中国证监会批准设立的证券投资咨询机构。
      </div>
      <div class="text2"> 开发者名称:北京天相财富管理顾问有限公司&nbsp;&nbsp;股多多软件版本号：v1.8.1.2 更新时间：2023/09/13</div>

      <div class=" qwer text3" style="text-decoration: underline;cursor:pointer;margin:5px 0">
        <span @click="open_yinsi()" style="margin-right:10px">隐私保护政策</span>
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </div>
      <div class="text4">以上功能均出自股多多股票软件相关渠道。因市场存在不确定性，产品具有局限性，历史收益不代表未来收益，仅供参考。投资有风险，入市需谨慎!</div>
      <div class="text4">Copyright © 2020-2023 天相财富版权所有 北京天相财富管理顾问有限公司 <img style="margin-left:10px"
          src="../assets/img/nationalEmblem.png" alt=""><a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank">京ICP备16068579号-8</a> <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010202011049" rel="noreferrer" target="_blank">京公网安备11010202011049号</a> </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {};
  },
  methods: {
    gouserServe() {
      this.$router.push("/userService");
    },

    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },
  },
};
</script>

<style  scopen lang="less">
.qwer span:hover {
  color: #fff;
}
.bottom {
  width: 100%;
  min-width: 1200px;
  height: 540px;
  background: url(../assets/img/index/bottom/bottom.png) no-repeat;
  background-size: 100% 100%;
  background-position: center;
  .list1 {
    width: 1200px;
    margin: 0 auto;
    height: 330px;
    // background-color: rgb(156, 118, 118);
    display: flex;
    align-items: center;
    .l {
      height: 100%;
      margin-right: 85px;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #ffffff;

      .liss2 {
        font-size: 21px;
        margin-bottom: 24px;
      }
      .liss3 {
        font-size: 16px;
      }
      .liss1 {
        margin-top: 19px;
        width: 217px;
        height: 37px;
        background: url(../assets/img/index/bottom/l.png) no-repeat;
        background-size: 100% 100%;
        background-position: center;
        line-height: 37px;
        text-align: center;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .c {
      color: #fff;
      width: 509px;
      height: 100%;
      display: flex;
      .lis {
        padding-top: 55px;
        .p1 {
          font-size: 16px;
          margin-bottom: 50px;
        }
        .p2 {
          font-size: 14px;
          margin-bottom: 33px;
        }
        .p3 {
          font-size: 14px;
          margin-bottom: 32px;
        }
        .p4 {
          font-size: 14px;
        }
      }
      .shus {
        padding-top: 54px;
      }
      .shus1 {
        margin-left: 44px;
        margin-right: 37px;
      }
      .shus2 {
        margin-left: 41px;
        margin-right: 37px;
      }
    }
    .r {
      display: flex;
      font-size: 10px;
      color: #fff;
      .lis1,
      .lis2 {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .lis1 {
        padding-left: 50px;
        margin-right: 40px;
      }
      .liss1 {
        width: 127px;
        height: 137px;
        background: url(../assets/img/index/bottom/r.png);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 103px;
        height: 103px;
      }
    }
  }

  // .list1 {
  //   width: 1200px;
  //   margin: 0 auto;
  //   height: 200px;
  //   // background-color: red;
  //   display: flex;
  //   align-items: center;

  //   .lis1 {
  //     width: 450px;
  //     height: 100%;
  //     .li-1 {
  //       margin-bottom: 37px;
  //     }
  //     .li-2 {
  //       margin-bottom: 37px;
  //     }
  //     .li-3 {
  //       margin-bottom: 37px;
  //     }
  //     .text1 {
  //       color: #808c9b;
  //       font-size: 16px;
  //       margin-right: 14px;
  //     }
  //     .text2 {
  //       font-size: 14px;
  //       color: #fff;
  //       margin-left: 20px;
  //     }
  //   }
  //   .lis2 {
  //     width: 300px;
  //     height: 100%;
  //     font-size: 16px;

  //     color: #808c9b;
  //     .li-1 {
  //       margin-bottom: 24px;
  //     }
  //     .li-2 {
  //       margin-bottom: 24px;
  //     }
  //     .li-3 {
  //       margin-bottom: 24px;
  //       span {
  //         font-size: 18px;
  //         color: #fff;
  //         margin-left: 10px;
  //       }
  //     }
  //     .li-4 {
  //       margin-bottom: 24px;
  //       span {
  //         font-size: 18px;
  //         color: #fff;
  //         margin-left: 10px;
  //       }
  //     }
  //   }
  //   .lis3 {
  //     width: 450px;
  //     height: 100%;
  //     display: flex;
  //     img {
  //       width: 155px;
  //       height: 155px;
  //       margin-bottom: 16px;
  //     }
  //     .li-1 {
  //       display: flex;
  //       flex-direction: column;
  //       // align-items: center;
  //       color: #fff;
  //       font-size: 16px;
  //       margin-right: 34px;
  //     }
  //   }
  // }
  .list2 {
    // background-color: #404040;
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    .text1 {
      padding-top: 25px;
    }
    .text1,
    .text2,
    .text3 {
      font-size: 10px;
      color: #748190;
      margin-bottom: 10px;
    }
    .text4 {
      font-size: 16px;
      color: #8b8987;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue